import * as types from "./types";
import {
    getEmailCampaignAxios,
    deleteEmailCampaignAxios,
    postEmailCampaignAxios,
    putEmailCampaignAxios,
    getEmailCampaignByIdAxios,
    updateCampaignStatus
} from "./services";

export async function getEmailCampaignListAction({ commit }) {
    commit(types.LOADING_EMAILCAMPAIGN, true);
    try {
        const { data } = await getEmailCampaignAxios();
        commit(types.GET_EMAILCAMPAIGN_LIST, data.result);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_EMAILCAMPAIGN, false);
    }
}

export async function removeEmailCampaignAction({ commit }, payload) {
    commit(types.LOADING_EMAILCAMPAIGN, true);
    try {
        await deleteEmailCampaignAxios(payload);
        commit(types.REMOVE_EMAILCAMPAIGN, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_EMAILCAMPAIGN, false);
    }
}

export async function addEmailCampaignAction({ commit }, payload) {
    commit(types.LOADING_EMAILCAMPAIGN, true);
    try {
        await postEmailCampaignAxios(payload);
        commit(types.ADD_EMAILCAMPAIGN, payload);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_EMAILCAMPAIGN, false);
    }
}

export async function updateEmailCampaignAction({ commit }, payload) {
    commit(types.LOADING_EMAILCAMPAIGN, true);
    try {
        await putEmailCampaignAxios(payload);
        commit(types.UPDATE_EMAILCAMPAIGN, payload);
    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_EMAILCAMPAIGN, false);
    }
}

export async function getEmailCampaignByIdAction({ commit }, payload) {
    commit(types.LOADING_EMAILCAMPAIGN, true);
    try {
        const { data } = await getEmailCampaignByIdAxios(payload);
        commit(types.GET_EMAILCAMPAIGNID, data.result);

    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_EMAILCAMPAIGN, false);
    }
}



export async function updateEmailCampaignStatusAction({ commit }, { id, status }) {
    commit(types.LOADING_EMAILCAMPAIGN, true);
    try {
        const response = await updateCampaignStatus(id, status);
        commit(types.UPDATE_EMAILCAMPAIGN_STATUS, { id, status });
        return response;
    } catch (e) {
        throw e;
    } finally {
        commit(types.LOADING_EMAILCAMPAIGN, false);
    }
}